/* eslint-disable */
import EVENTS from '@/utils/Constants/Events';
import { lockBodyScroll, unlockBodyScroll } from '@/utils/Common/Modal';

export const toggleCompareTray = event => {
  if (
    !event.currentTarget.parentElement.parentElement.classList.contains(
      'bra-compareTray--expanded',
    )
  ) {
    event.currentTarget.parentElement.parentElement.classList.toggle(
      'bra-compareTray--collapsed',
    );
  } else {
    event.currentTarget.parentElement.parentElement.classList.remove(
      'bra-compareTray--collapsed',
    );
  }
};

const expandComparedProducts = () => {
  const compareTray = document.getElementsByClassName('bra-compareTray')[0];
  const productTiles = compareTray.getElementsByClassName('bra-prodTile');
  for (let i = 0; i < productTiles.length; i++) {
    productTiles[i].classList.remove('bra-prodTile--collapsed');
  }
};

const collapseCompareProducts = () => {
  const compareTray = document.getElementsByClassName('bra-compareTray')[0];
  const productTiles = compareTray.getElementsByClassName('bra-prodTile');
  for (let i = 0; i < productTiles.length; i++) {
    productTiles[i].classList.add('bra-prodTile--collapsed');
  }
};

export const toggleExpandedCompareTray = (action = 'toggle') => {
  const compareTray = document.getElementsByClassName('bra-compareTray')[0];
  const compareTrayMainBox = document.getElementsByClassName(
    'bra-compareTray__main',
  )[0];

  const expandCompareTray = () => {
    if (!compareTray.classList.contains('bra-compareTray--expanded')) {
      compareTrayMainBox.style.opacity = '0';
      compareTray.classList.add('bra-compareTray--expanded');
      DLG.EVE.emit(EVENTS.LISTING.COMPARE.TOGGLE, true);
      expandComparedProducts();
      lockBodyScroll();
      setTimeout(() => {
        compareTrayMainBox.removeAttribute('style');
      }, 350);
    }
  };

  const shrinkCompareTray = () => {
    if (compareTray.classList.contains('bra-compareTray--expanded')) {
      compareTrayMainBox.style.opacity = '0';
      unlockBodyScroll();
      if (
        compareTrayMainBox.classList.contains('bra-compareTray__main--sticky')
      ) {
        removeStickyMainBox();
      }
      compareTray.scrollTop = 0;
      compareTray.classList.remove('bra-compareTray--expanded');
      DLG.EVE.emit(EVENTS.LISTING.COMPARE.TOGGLE, false);
      collapseCompareProducts();
      setTimeout(() => {
        compareTrayMainBox.removeAttribute('style');
      }, 350);
    }
  };

  setTimeout(() => {
    if (action === 'expand') expandCompareTray();
    if (action === 'shrink') shrinkCompareTray();
    if (action === 'toggle') {
      if (!compareTray.classList.contains('bra-compareTray--expanded')) {
        expandCompareTray();
      } else {
        shrinkCompareTray();
      }
    }
  }, 300);
};

const handleStickyMainBox = () => {
  const compareTrayMainBox = document.getElementsByClassName(
    'bra-compareTray__main',
  )[0];
  const comparsionTableWrap = document.getElementsByClassName(
    'bra-compareTray__table',
  )[0];
  comparsionTableWrap.style.paddingTop = compareTrayMainBox.offsetHeight + 'px';
  compareTrayMainBox.classList.add('bra-compareTray__main--sticky');
};

const removeStickyMainBox = () => {
  const compareTrayMainBox = document.getElementsByClassName(
    'bra-compareTray__main',
  )[0];
  const comparsionTableWrap = document.getElementsByClassName(
    'bra-compareTray__table',
  )[0];
  if (comparsionTableWrap) comparsionTableWrap.removeAttribute('style');
  compareTrayMainBox.classList.remove('bra-compareTray__main--sticky');
};

export const toggleStickyComparsionMain = () => {
  const compareTray = document.getElementsByClassName('bra-compareTray')[0];
  if (compareTray.classList.contains('bra-compareTray--expanded')) {
    const scrolledValue = compareTray.scrollTop;

    if (scrolledValue >= 240) {
      const compareTrayMainBox = document.getElementsByClassName(
        'bra-compareTray__main',
      )[0];
      if (
        !compareTrayMainBox.classList.contains('bra-compareTray__main--sticky')
      ) {
        handleStickyMainBox();
        collapseCompareProducts();
      }
    } else {
      removeStickyMainBox();
      expandComparedProducts();
    }
  }
};
